import StoreConstants from "@/StoreConstants";
import store from '@/store'

class CouponHelper {
  run(coupon, onlyAnnual) {
    // eslint-disable-next-line no-console
    console.log('TIMING: couponHelper.run ' + coupon + ' ' + onlyAnnual);
    if(coupon && coupon !== 'null' && coupon !== 'undefined' && coupon !== '') {
      store.commit(StoreConstants.commits.setCoupon, coupon)
    }
    if(onlyAnnual) {
      if(onlyAnnual === 'true') {
        store.commit(StoreConstants.commits.setOnlyAnnual, Date.now())
      } else {
        store.commit(StoreConstants.commits.setOnlyAnnual, 0)
      }
    }
  }
}

export default  (new CouponHelper())
